<template lang="pug">
tr(
  :key="index"
  data-test="candidate-row"
  :class="{'updated' : item.animation, 'app-table__row_expanded': isExpanded}"
  :style="{'background-color': candidateColor}"
).row-animation
  td
    v-checkbox(
      data-test="c-checkbox-select"
      hide-details 
      :value="isSelected"
      :key="index" @change="select"
      @click.native="selectWithShiftkey({event: $event, item: item, index: index})"
    ).mt-0
    div.row-labels
      label-primary(v-for="label in currentLabels" :key="label.ID" :text="label.name" :color="label.color")


  td.app-table__cell.app-table__cell_small
    .d-flex
      v-icon(@click="copyData(item)").hoverable mdi-content-copy
      v-icon(
        :class="{'expanded': isExpanded}" 
        @click="goToEdit({expand, isExpanded})"
        data-test="candidate-open"
      ) mdi-chevron-right

  td( data-test="candidate-position" @click="goToEdit({expand, isExpanded})") {{ positionInList }}

  td
    candidate-color(:activeItems="[item]")

  td(@click="goToEdit({expand, isExpanded})" v-if="!isCursssusenPage")
    div.table-date.table-date_additional.text-center {{ item.appPlacedAtFormatted }}
    div.table-date.table-date_additional.text-center {{ item.appPaidAtFormatted }}

  td(:style="{maxWidth: '100px'}" data-test="candidate-name" @click="goToEdit({expand, isExpanded})")
    | {{ item.fullName }}

  td(@click="goToEdit({expand, isExpanded})")
    template(v-if="item.candidateNumber" ) 
      span.white-space-normal(:style="{maxWidth: '100px'}" v-html="candidateNumberSplicedOnTwoElement").cdr
    candidate-label(:model="item")

  td(
    data-test="candidate-bday"
    @click="goToEdit({expand, isExpanded})"
    ).nowrap
    | {{ item.candidateBirthday }}
    div.white-space-normal(:style="{maxWidth: '100px'}") {{ item.candidateTel }}
  td(:style="{maxWidth: '100px'}" @click="goToEdit({expand, isExpanded})" ) {{ cbrAccount }}

  td(:style="{maxWidth: '100px'}" v-if="isCursssusenPage")
    courseConfiguration(:ID="item.ID" :configurationID="item.course_configuration")

  td(:style="{maxWidth: '100px'}" @click="goToEdit({expand, isExpanded})" ).text-center {{ item.applicationId }}

  td( @click="$emit('click:payments', item)" )
    check-boolean(:value="item.is_course_paid")
    v-menu(top offset-y max-width="400" open-on-hover content-class="templates-tooltip")
      template(v-slot:activator="{ on }")
        span(v-on="on").hover-pointer.ml-1 {{ item.paidAmount}} &euro;
      paymentsLog(:list="item.payments")

  td(
    :style="{maxWidth: '120px', minWidth: '100px'}"
    :class="{'exchanged': item.wasExchanged, 'mijn-reservation': item.isMijnReservation}"
    @click="goToEdit({expand, isExpanded})"
    )
    p(v-if="!item.reservedExam.location && !item.reservedExam.examDate").text-center -
    p(v-if="item.reservedExam.location").mt-0.mb-0.text-center.overflow-text  {{ item.reservedExam.location}}
    p(v-if="item.reservedExam.examDate").mb-0.mt-0.text-center.overflow-text {{ item.reservedExam.examDate}}

  td(:style="{maxWidth: '100px'}" @click="goToEdit({expand, isExpanded})" ) {{ item.productName }}

  td(v-if="isCursssusenPage")
    willCome(:will_come_to_course="item.willComeToCourse" @update="updateCandidateWillCome")

  td( data-test="cbr-status" @click="goToEdit({expand, isExpanded})" v-if="!isCursssusenPage") {{ item.status }}

  td(@click="goToEdit({expand, isExpanded})").comment-td
    show-more(:text="item.appComment"  :classes="['text-ellipsis']")
  
  td
    LogEmailProvider(:getLogs="getSentEmails" v-slot:default="emailLogs")
      baseEmailTemplateProvider
        template(
          v-slot:default="baseEmail"
        )
          EmailTemplatesSendProvider(
            :ID="item.ID" 
            :model="item"
            :formErrors="baseEmail.formErrors"
            v-slot:default="sendProvider"
            @send="emailLogs.addToLogs"
          )
            EmailTemplates(
              :items="baseEmail.list"
              :itemsLoading="baseEmail.listLoading"
              :editedTemplate="baseEmail.editedTemplate"
              :loadData="baseEmail.loadData"
              :logs="baseEmail.logs"
              :formErrors="baseEmail.formErrors"
              :processing="baseEmail.processing"
              :maxItemsShowing="8"
              @templateSelected="baseEmail.loadTemplateData"
              @onAddCustomTemplate="baseEmail.loadCreateTemplate"
              @submit="sendProvider.sendEmail"
              @save="baseEmail.post"
              @update="baseEmail.update"
              @remove="baseEmail.remove"
            )
              template(v-slot:tooltip)
                v-menu(left offset-x max-width="400" open-on-hover content-class="templates-tooltip" @input="emailLogs.setTemplateTooltipShowing")
                  template(v-slot:activator="{ on }")
                      v-icon(v-on="on") mdi-email
                  templatesLog(:list="emailLogs.logs")
              template(v-slot:side)
                v-col
                  h3.email-templates__subtitle Email logs
                  templatesLog(:list="emailLogs.logs" :loading="emailLogs.logsLoading")

  td.table-dates.cell-dates(v-if="!isCursssusenPage")
    course-confirmed(:item="item" ).cell-dates
  
  td(@click="goToEdit({expand, isExpanded})" v-if="!isCursssusenPage").nowrap
    div(v-for="(request, index) in item.sortedFilteredRequests" :key="index").table-reservation
      reservation-date(
        :request="request"
        :filteredRequests="item.sortedFilteredRequests"
        :index="index"
        v-if="request.examDate && index < 2"
      )
  td.note-td
    note(:value="item.notes" :ID="item.ID")
  //- tr
  //-   td(colsspan="12") haha
</template>

<script>
import CandidatesService from "@/app/admin/modules/candidates/core/candidates-service"
import copyMixin from "@/mixins/copy.mixin"
import courseConfiguration from "./curssusen/CMCourseConfiguration.vue"
import checkBoolean from "@/components/global/CheckBoolean.vue"

import { mapState } from 'vuex'

export default {
  mixins: [copyMixin],
  inject: ['candidatesSvc'],

  props: {
    item: {
      type: Object,
      requred: true
    },
    index: Number,
    isSelected: Boolean,
    select: Function,
    expand: Function,
    isExpanded: Boolean,
    activeItems: Array,
    labels: Array,
    primaryPagination: Object

  },

  data: () => ({
    svc: new CandidatesService(),
    candidateColorID: null,
  }),

  mounted() {
    this.setColorId(this.item.color)
  },

  watch: {
    'item.color'(value) {
      this.setColorId(value)
    }
  },

  computed: {
    ...mapState('crmCandidateColors', {
      colors: state => state.colors
    }),
    candidateColor() {
      if (this.candidateColorID) {
        const color = this.colors.find(color => color.id === this.candidateColorID)
        return color && color.hex_color_code ? color.hex_color_code : ''
      } else {
        return ''
      }
    },
    positionInList() {
      return (this.index + 1) + (this.primaryPagination.page - 1) * this.primaryPagination.size;
    },

    // it's fix for 3cx plugin on chrome
    candidateNumberSplicedOnTwoElement() {
      let number = this.item.candidateNumber + ''
      let numberArr = number.split('')
      let halfLength = Math.ceil(numberArr.length / 2);  
      let leftSide = numberArr.splice(0, halfLength);
      let html = `<span>${leftSide.join('')}</span><span>${numberArr.join('')}</span>`
      return html
    },

    cbrAccount() {
      return this.$store.getters['cbrUser/getNameByID'](this.item.accountUsername)
    },

    isCursssusenPage() {
      return this.$route.name === this.$ROUTER_NAMES.CURSSUSEN
    },

    currentLabels() {
      if(!this.item.labels || !this.labels) return []
      return this.item.labels.map(labelID => {
        let sameLabel = this.labels.find(label => {
          if(label.ID === labelID) return label
        })
        if(sameLabel) return sameLabel
      })
    }

  },

  methods: {
    async updateCandidateWillCome(value) {
      this.svc.updateWillCome(this.item.ID, value)
      this.$emit('onWillComeUpdate')
    },
    setColorId(colorId) {
      this.candidateColorID = colorId;
    },
    copyData(model) {
      let data = model.getSpreadsheetData(this.$store)
      this.copy(data)
    },

    getSentEmails() {
      return this.item.sentEmails
    },

    goToEdit({expand, isExpanded}) {
      this.$emit('onGoToEdit', {expand, isExpanded})
    },

    selectWithShiftkey({event, item, index}) {
      if(!this.activeItems.length || !event.shiftKey) return
      this.$emit('selectedWithShiftkey', {item: item, index: index}) 
    },
  },

  provide: function() {
    return {
      svc: () => this.candidatesSvc
    }
  },

  components: {
    reservationDate: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesReservedDate.vue'),
    paymentsLog: () => import('@/app/admin/modules/candidates/components/payments/CandidatesPaymentLog.vue'),
    EmailTemplatesProvider: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesEmailTemplatesProvider.vue'),
    EmailTemplates: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesEmailTemplates'),
    courseConfiguration: courseConfiguration,

    baseEmailTemplateProvider: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesEmailBaseProvider.vue'),
    EmailTemplatesSendProvider: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesEmailSendProvider.vue'),
    LogEmailProvider: () => import('@/app/admin/modules/candidates/components/candidates/CandidateEmailLogProvider.vue'),
    templatesLog: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesETempLog.vue'),
    note: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesNote.vue'),
    candidateLabel: () => import('@/app/admin/modules/candidates/components/candidates/CandidatesLabel.vue'),
    courseConfirmed: () => import('@/app/admin/modules/candidates/components/candidates/CandidateCourseConfirmed.vue'),
    showMore: () => import('@/components/global/showMoreTooltip.vue'),
    labelPrimary: () => import('@/components/global/LabelPrimary.vue'),
    candidateColor: () => import('@/app/admin/modules/candidates/components/CandidateColor.vue'),
    willCome: () => import('./СMWillCome.vue'),
    checkBoolean
  }
}
</script>

<style lang="scss" scoped>

.row-animation {
  transition: all 1s;
  cursor: pointer;
  height: 60px;
}

.updated {
  background-color: rgba($succes-color, .3) !important;
}

.expanded {
  transform: rotate(90deg);
  color: $primary-color !important;
}


.table-dates {
  width: 170px;
  line-height: 1.3;
}

.table-reservation {
  margin: 0 -4px;
}

.app-table td {
  font-size: 12px;
  line-height: 1.3;
}

.app-table__row_expanded {
  > td {
    border-top: 1px solid $primary-color;
    &:first-child {
      border-left: 1px solid $primary-color;
    }
    &:last-child {
      border-right: 1px solid $primary-color;
    }
  }
}

.white-space-normal{
  white-space: normal;
}

.cdr {
  margin: 0 -4px;
}

.note-td {
  max-width: 150px;
}
.comment-td {
  max-width: 80px;
}

.row-labels {
  position: absolute;
  margin-top: 5px;
}

.exchanged{
  background-color: $warning-color;
}

.mijn-reservation{
  background-color: $yellow-color;
}

</style>
